import styled, { keyframes } from 'styled-components';

interface IAlert {
  show: boolean;
}

export const UsersContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  height: fit-content;
  /* min-height: 100vh; */
  gap: 24px;
  padding: 40px;

  td {
    overflow: hidden;
    
    p {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;
  height: 100%;

  button {
    width: 284px;
    text-align: center;
  }
  section {
    display: flex;
    height: 48px;
    gap: 16px;
    flex: 1;
    div {
      min-width: 284px;
      flex: 1;

      input,
      select {
        font-size: 16px;
      }
    }
  }
  label {
    flex: 1;
    position: relative;
    min-width: 264px;

    input {
      width: 100%;
      padding-left: 44px;
      font-size: 14px;
      font-weight: 300;
      min-width: 264px;
    }

    span {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      border-radius: 12px;
      left: 0px;
      top: 0px;
      height: 48px;
      width: 40px;

      &:active {
        transform: translate(1px, 1px);
      }
      svg {
        color: ${({ theme }) => theme.colors.orange.primary};
        height: 20px;
        width: 20px;
      }
    }
  }
  div {
    input {
      min-width: 256px;
    }
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;

  div {
    cursor: pointer;
    max-width: fit-content;
    height: fit-content;
    padding: 0px 0px;

    :hover {
      color: ${({ theme }) => theme.colors.orange.primary};
    }

    svg {
      color: ${({ theme }) => theme.colors.gray[500]};
    }
  }
`;

export const InputsModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 25px;

  input {
    border: none;
    background-color: #f7f7f7;
    color: #616161;
    text-align: center;
    font-size: 16px;

    &::placeholder {
      color: #b3b3b3;
    }
  }

  .storeContent {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-top: 10px;
  }
`;

const fadeInAndOut = keyframes`
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

export const Alert = styled.p<IAlert>`
  animation: ${fadeInAndOut} 3s linear;
  animation-fill-mode: forwards;
  opacity: 0;

  display: ${(props) => (props.show ? 'block' : 'none')};
  text-align: center;
  color: ${({ theme }) => theme.colors.green.primary};
`;
